/* RESPONSIBLE TEAM: team-reporting */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type RegionService from 'embercom/services/region-service';
import ENV from 'embercom/config/environment';
import safeWindowOpen from 'embercom/lib/safe-window-open';

export default class ExternalSharedLinksController extends Controller {
  @service declare regionService: RegionService;

  queryParams = [];

  @tracked model: any;

  get formattedSharedLinks() {
    return this.model.sharedLinks.map((link: any) => {
      let baseUrl = this.getPublicLinkBaseUrl();
      return {
        report_title: link.report_title,
        public_link: `${baseUrl}/report-snapshot/${link.public_link}`,
        created_at: new Date(link.created_at * 1000),
      };
    });
  }

  private getPublicLinkBaseUrl(): string {
    if (ENV.environment === 'development' || ENV.environment === 'test') {
      return 'http://intercom.test';
    }
    return this.regionService.appUrl(this.regionService.region);
  }

  @action
  openInNewTab(url: string) {
    safeWindowOpen(url, '_blank');
  }
}
